import { render, staticRenderFns } from "./GlobalStylesRender.vue?vue&type=template&id=25cd8545"
import script from "./GlobalStylesRender.vue?vue&type=script&lang=js"
export * from "./GlobalStylesRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports